import { useContextWithValidation } from '@adsk/alloy-react-context';

import LocaleContext from '../context';

const isUnitTest = () => process.env.NODE_ENV === 'test';

export default () => {
  const contextValue = useContextWithValidation(LocaleContext, {
    hook: 'useLocale',
    provider: 'LocaleProvider',
    shouldThrowError: !isUnitTest(),
  });

  return {
    locale: contextValue?.locale,
    setLocale: contextValue?.setLocale,
  };
};
